
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcWindIndicator as ObcWindIndicatorElement} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/wind-indicator/wind-indicator.js';
 
 
 

 
 export const ObcWindIndicator = createComponent({
   react: React,
   tagName: 'obc-wind-indicator',
   elementClass: ObcWindIndicatorElement,
   events: {
     
   }
  });
 
 